import React, { useEffect, useMemo, useState } from "react";
import TableContainer from "../../components/Common/TableContainer";

import Breadcrumbs from '../../components/Common/Breadcrumb';
import { Card, CardBody, Container,TabContent, TabPane, Collapse, NavLink, NavItem, Nav, Row, Col,Label, Input,Button, CardTitle, Badge, ModalFooter } from "reactstrap";
import { products, } from "../../common/data/ecommerce";
import {  Modal,ModalBody, ModalHeader} from "reactstrap";
import { useSelector } from "react-redux";
import Select from "react-select";
import { disableZone, enableZone, GetlisteZones, updateZone, UploadFileZone } from '../../services/ZonesServices/Api';
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import classnames from "classnames";
import { UpdateMemeberProfile } from "../../services/ProfileServices/Api";
import Dropzone from "react-dropzone";
import { Form } from "react-router-dom";
import config from '../../config'
import { AddAnimaux, disableAnimaux, enableAnimaux, GetlisteAnimaux, GetlisteAnimauxVivarium, updateAnimaux, UploadFileAnimaux } from "../../services/AnimauxServices/Api";

const optionGroup = [
	{
		options: [
			{ label: "Mustard", value: "Mustard" },
			{ label: "Ketchup", value: "Ketchup" },
			{ label: "Relish", value: "Relish" }
		]
	},
];

const Vivarum = () => {
  const [modalUpdateIsOpen,setmodalUpdateIsOpen] = useState(false)
  const [ListAnimals,setListAnimals] = useState([])
  const [User,setUser] = useState()
  const [dropdownValues, setDropdownValues] = useState({});
  const  [openmodal, setopenModal] = useState(false)
  const [activeTabJustify,setactiveTabJustify] = useState("1")
  const [memberSelected , setmemberSelected] = useState()
  const [selectedCity , setselectedCity]  = useState("")
  const [NameZone_FR , setNameZone_FR]  = useState("")
  const [NameZone_Ar , setNameZone_Ar]  = useState("")
  const [NameZone_Eng , setNameZone_Eng]  = useState("")
  const [ZoneOpened , setZoneOpened] = useState({})
  const [tel , settel]  = useState("")
  const [ShowConfirmModal, setShowConfirmModal] = useState(false)
  const [ShowConfirmModalII, setShowConfirmModalII] = useState(false)

  const  [openedZone, setopenedZone] = useState()
  const [Latitude, setLatitude] = useState("")
  const [longitude, setlongitude] = useState("")

  const [DesZone_Fr , setDesc_Fr]  = useState("")
  const [DesZone_Ar , setDesc_Ar]  = useState("")
  const [DesZone_Eng , setDesc_Eng]  = useState("")
  const [ZoneSelected , setZoneSelected]  = useState("")


  const [adr_ferm , setadr_ferm]  = useState("")
  const [Email, setEmail] = useState()
  const [DaysSelected, setDaysSelected] = useState([])
  const [openmodalevaluate, setopenmodalevaluate] = useState(false)
  const [evaluatYear, setevaluatYear] = useState('')
  const [evaluatCmnt, setevaluatCmnt] = useState('')
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [OptionZones, setOptionZones] = useState([])

 



  

  const handleClickMember = (member) =>{
     setZoneOpened(member) 
     setLatitude(member['lat'])
    //  setZoneSelected({ label: member.zone['title_fr'], value: member.zone['id'] })
     setlongitude(member['lang'])
     setNameZone_FR(member['title_fr'])
     setNameZone_Ar(member['title_ar'])
     setNameZone_Eng(member['title_en'])

     setDesc_Fr(member['description_fr'])
     setDesc_Ar(member['description_ar'])
     setDesc_Eng(member['description_en'])


     setopenModal(true)
  }



  const  toggleCustomJustified = (tab) => {
		setactiveTabJustify(tab)
	}

  const  handleSelectCity = async (selectedGroup) => {
    console.log(selectedGroup)
    setselectedCity(selectedGroup);
  };




  const columns = useMemo(
    () => [
        {
            Header: "Image",
            accessor: "img",
            disableFilters: true,
            filterable: false,
        },
      {
        Header: "Nom",
        accessor: "title_fr",
        disableFilters: true,
        filterable: false,
      },
      // {
      //   Header: "Zone",
      //   accessor: "zone",
      //   disableFilters: true,
      //   filterable: false,
      // },
      {
        Header: "Description",
        accessor: "description_fr",
        disableFilters: true,
        filterable: false,
      },
      {
        Header: "Status",
        accessor: "disable",
        disableFilters: true,
        filterable: false,
      },
      {
        Header: "Action",
        accessor: "action",
        disableFilters: true,
        filterable: false,
      },
    
    ],
  );




  const GetData = async () =>{
    await GetlisteAnimauxVivarium().then(res =>{
      console.log(res)
      const filteredZones = res.filter(zone => zone.disable == false);
      setListAnimals(res)
    }).catch(err =>{
      console.log(err)
    })
  }

    useEffect(() =>{
      const Data = JSON.parse(localStorage.getItem("authUser"))
      setUser(Data)

      GetData()
    },[])

    const initForm = () =>{
      setSelectedFiles([])
      setNameZone_Ar("")
      setNameZone_FR("")
      setNameZone_Eng("")
      setDesc_Ar("")
      setDesc_Eng("")
      setDesc_Fr("")
      setZoneOpened({})
    }

    const handleAcceptedFiles = (files) => {
      const updatedFiles = files.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
          htmlFormattedSize: htmlFormatBytes(file.size),
        })
      );
      setSelectedFiles(updatedFiles);
    };

    const htmlFormatBytes = (bytes, decimals = 2) => {
      if (bytes === 0) return "0 Bytes";
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    };

    const formatBytes = (bytes, decimals = 2) => {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  };

    const handleRemoveFile = (index) => {
      setSelectedFiles(prevFiles => {
          const updatedFiles = [...prevFiles];
          updatedFiles.splice(index, 1);
          return updatedFiles;
      });
  };


  const handleupdateZone = async () =>{
    if(selectedFiles.length !== 0 ){
      
    const formData = new FormData();
    formData.append('file', selectedFiles[0]);
      await UploadFileAnimaux(formData).then(async res =>{
        console.log(res)
      ZoneOpened['lat'] = Latitude
      ZoneOpened['lang'] = longitude
      ZoneOpened['title_fr'] = NameZone_FR
      ZoneOpened['description_fr'] = DesZone_Fr
      ZoneOpened['title_ar'] = NameZone_Ar
      ZoneOpened['description_ar'] = DesZone_Ar
      ZoneOpened['title_en'] = NameZone_Eng
      ZoneOpened['description_en'] = DesZone_Eng
      ZoneOpened['img'] = res
      ZoneOpened['updatedAt'] = new Date()



      await updateAnimaux(ZoneOpened).then(res =>{
        console.log(res.status)
        if (res.status === 200) {
  
          toastr.success("l'animal " + NameZone_FR + " était bien modifié" )
          setopenModal(false)
          initForm()
          GetData()
  
        } else {
          toastr.error("Une erreur est survenue. Merci de réessayer plus tard." )
  
        }
      })
    })
  } else {
    ZoneOpened['lat'] = Latitude
    ZoneOpened['lang'] = longitude
    ZoneOpened['title_fr'] = NameZone_FR
    ZoneOpened['description_fr'] = DesZone_Fr
    ZoneOpened['title_ar'] = NameZone_Ar
    ZoneOpened['description_ar'] = DesZone_Ar
    ZoneOpened['title_en'] = NameZone_Eng
    ZoneOpened['description_en'] = DesZone_Eng
    ZoneOpened['updatedAt'] = new Date()

    await updateAnimaux(ZoneOpened).then(res =>{
      console.log(res.status)
      if (res.status === 200) {

        toastr.success("l'animal " + NameZone_FR + " était bien modifié" )
        setopenModal(false)
        initForm()
        GetData()


      } else {
        toastr.error("Une erreur est survenue. Merci de réessayer plus tard." )

      }
    })

  }
}


 
  const AddAnim = async () =>{

    console.log(selectedFiles[0])
    console.log(typeof(selectedFiles[0]))

    const formData = new FormData();
    formData.append('file', selectedFiles[0]);

    await UploadFileAnimaux(formData).then(async res =>{
      console.log(res)

    const DataPost = {
      "description_fr": DesZone_Fr,
      "title_fr": NameZone_FR,
      "description_ar": DesZone_Ar,
      "title_ar": NameZone_Ar,
      "description_en" : DesZone_Eng,
      "title_en" : NameZone_Eng,
      "img" : res,
      "lang" : longitude,
      "lat" : Latitude,
      "isVivarum" : true
    }
    await AddAnimaux(DataPost).then(res =>{
      console.log(res.status)
      if (res.status === 201) {

        toastr.success('la zone ' + NameZone_FR + " était bien ajouté" )
        setopenModal(false)
        initForm()
        GetData()


      } else {
        toastr.error("Une erreur est survenue. Merci de réessayer plus tard." )

      }
    })

    })

    // const blobData = await fetch(URL.createObjectURL(selectedFiles[0])).then((res) => res.blob());
    // const blob = new Blob([blobData], { type: selectedFiles[0].type });
    // formData.append('files', blob, selectedFiles[0].name);


  }

  const isObjectEmpty = (obj) => {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
  };

  const handleAddnewZone = () => {
    setZoneOpened({})
    initForm()
    setopenModal(true)
  }

  const handleClickRemove = async () => {

    await disableAnimaux(openedZone).then((res) =>{
      if (res.status === 200) {
      GetData()
      setShowConfirmModal(false)
      } else {
        toastr.error("Une erreur est survenue. Merci de réessayer plus tard." )
      }
    })

  }

  const handleClickEnable = async (Zone) =>{

    
    await enableAnimaux(openedZone).then((res) =>{
      console.log(res)
      if (res.status === 200) {
        toastr.success("la zone était bien activé" )
        GetData()
        setShowConfirmModalII(false)
      } else {
        toastr.error("Une erreur est survenue. Merci de réessayer plus tard." )
      }
       
     })

  }

  const handleSelectZone = (zone) =>{
    setZoneSelected(zone)
  }


  // const updateZone = async () =>{
  //   console.log(memberSelected.profile)
  //   const Data = JSON.parse(localStorage.getItem("authUser"))
  //   memberSelected.profile['adrs_res'] = DesZone
  //   memberSelected.profile['Tel'] = tel
  //   memberSelected.profile['adrs_ferme'] = adr_ferm
  //   memberSelected.profile['City'] = selectedCity?.value
  //   memberSelected.profile['days_dispo'] = JSON.stringify(DaysSelected)

  //   const DataProfile = { Data : memberSelected.profile }
    
  //   await UpdateMemeberProfile(Data.token, DataProfile ).then(res =>{
  //     setopenModal(false)
  //     if(res['status'] == "success"){
  //       toastr.success('le profil de ' + NameZone + " était bien misé à jour" )
  //     }
  //   }).catch(err =>{
  //     toastr.error("Erreur lors de mises à jour le profile ")
  //   })
  // }



  

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Listes animales"
            breadcrumbItems={[]}
          />
        
          <Card>
          <div className="d-flex justify-content-end m-2 mt-2">
                <Button color="success" onClick={handleAddnewZone}>
                    Ajouter une page
                </Button>
          </div>
            <CardBody>
              <TableContainer
                columns={columns || []}
                data={ListAnimals || []}
                isPagination={false}
                // isGlobalFilter={false}
                iscustomPageSize={false}
                isBordered={false}
                customPageSize={10}
                // openModalUpdate={openModal}
                // isAddOptions={true}
                ShowPaggination={false}
                handleClickRow={handleClickMember}
                handleClickRemove={(Zone) =>{
                  setopenedZone(Zone.id)
                  setShowConfirmModal(true)
                }}
                handleClickEnable={(Zone) =>{
                  setopenedZone(Zone.id)
                  setShowConfirmModalII(true)

                }}
                dropdownData = {dropdownValues}
                userData={User}
              />
            </CardBody>
          </Card>
          <Modal
                size="xl"
                isOpen={openmodal}
                toggle={() =>{setopenModal(false)}}
                >
                <ModalHeader >
                 Information d'animal : {ZoneOpened['title_fr']}
                </ModalHeader>
                <ModalBody>
                  <Row style={{marginBottom : 20}}>
                  <Col lg="6">
                  <Label className="form-label" htmlFor="basicpill-firstname-input1">Image</Label>
                    <Dropzone
                        onDrop={acceptedFiles => handleAcceptedFiles(acceptedFiles)}
                    >
                        {({ getRootProps, getInputProps }) => (
                            <div className="dropzone" >
                                <div className="dz-message needsclick" {...getRootProps()}>
                                    <input {...getInputProps()} />
                                    <div className="mb-3">
                                        <i className="display-4 text-muted ri-upload-cloud-2-line"></i>
                                    </div>
                                    <span style={{fontSize : 14}}>Déposez le fichier ici ou cliquez pour télécharger.</span>
                                </div>
                            </div>
                        )}
                    </Dropzone>
                    </Col>
                    <Col lg="6">
                    {selectedFiles.some(file => file.type.startsWith('image/')) && (
                      <div className="mt-3" style={{alignItems : 'center', justifyContent : 'center'}}>
                        <Row style={{alignItems : 'center', justifyContent : 'center'}}>
                          {selectedFiles.filter(file => file.type.startsWith('image/')).map((file, index) => (
                            <Col key={index} xs="6" sm="4" md="3" lg="2">
                              <img
                                src={URL.createObjectURL(file)}
                                alt={file.name}
                                style={{ width: "190%", height: "190%", marginBottom: '10px', borderRadius : 150, boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)"}}
                                />
                            </Col>
                          ))}
                        </Row>
                      </div>
                    )}
                     {(!isObjectEmpty(ZoneOpened) && selectedFiles.length == 0) &&
                      <div className="mt-3" style={{alignItems : 'center', justifyContent : 'center'}}>
                      <Row style={{alignItems : 'center', justifyContent : 'center'}}>
                          <Col xs="6" sm="4" md="3" lg="2">
                           
                            <img
                              src={config.path + ZoneOpened["img"]}
                              alt={"icon"}
                              style={{ width: "190%", height: "190%", marginBottom: '10px',borderRadius : 150 , boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)"}}
                            />
                          </Col>
                      </Row>
                    </div> 
                    }


                    {selectedFiles.length > 0 && (
                        <Card className="mt-3">
                            <CardBody>
                                {selectedFiles.map((file, index) => (
                                    <Row key={index} className="align-items-center mb-2">
                                        <Col className="col-auto">
                                            <h6 className="text-truncate font-size-14 mb-0">{file.name}</h6>
                                        </Col>
                                        <Col>
                                            <Badge color="primary">{formatBytes(file.size)}</Badge>
                                        </Col>
                                        <Col className="col-auto">
                                            <Button color="danger" size="sm" onClick={() => handleRemoveFile(index)}><i className="ri-delete-bin-2-line"></i></Button>
                                        </Col>
                                    </Row>
                                ))}
                               
                            </CardBody>
                        </Card>
                    )}
                    </Col>
                    </Row>
                <React.Fragment>
                        <Row>   
                            <Col lg="6">
                                <div className="mb-3">
                                    <Label className="form-label" htmlFor="basicpill-firstname-input1">Latitude</Label>
                                    <Input type="text" className="form-control" id="basicpill-firstname-input1" value={Latitude} onChange={(e) =>setLatitude(e.target.value)} />
                                </div>
                            </Col>
                            <Col lg="6">
                                <div className="mb-3">
                                    <Label className="form-label" htmlFor="basicpill-firstname-input1">longitude</Label>
                                    <Input type="text" className="form-control" id="basicpill-firstname-input1" value={longitude} onChange={(e) =>setlongitude(e.target.value)} />
                                </div>
                            </Col>
                           
                        </Row>
                          <Row>
                          <Col lg="4">

                                  <div className="mb-3">
                                      <Label className="form-label" htmlFor="basicpill-firstname-input1">Nom - Fr</Label>
                                      <Input type="text" className="form-control" id="basicpill-firstname-input1" value={NameZone_FR } onChange={(e) =>setNameZone_FR(e.target.value)} />
                                  </div>
                          </Col>

                          <Col lg="4">

                                  <div className="mb-3">
                                      <Label className="form-label" htmlFor="basicpill-firstname-input1">Nom - Ar</Label>
                                      <Input type="text" className="form-control" id="basicpill-firstname-input1" value={NameZone_Ar } onChange={(e) =>setNameZone_Ar(e.target.value)} />
                                  </div>
                          </Col>

                          <Col lg="4">

                                  <div className="mb-3">
                                      <Label className="form-label" htmlFor="basicpill-firstname-input1">Nom - Eng</Label>
                                      <Input type="text" className="form-control" id="basicpill-firstname-input1" value={NameZone_Eng } onChange={(e) =>setNameZone_Eng(e.target.value)} />
                                  </div>
                          </Col>
                          
                          <Row>
                              <Col lg="4">
                                  <div className="mb-3">
                                      <Label className="form-label" htmlFor="basicpill-address-input1">Description - Fr</Label>
                                      <textarea id="basicpill-address-input1" className="form-control" rows="5" onChange={(e) =>setDesc_Fr(e.target.value)} value={DesZone_Fr }></textarea>
                                  </div>
                              </Col>
                              <Col lg="4">
                                  <div className="mb-3">
                                      <Label className="form-label" htmlFor="basicpill-address-input1">Description - Ar</Label>
                                      <textarea id="basicpill-address-input1" className="form-control" rows="5" onChange={(e) =>setDesc_Ar(e.target.value)} value={DesZone_Ar }></textarea>
                                  </div>
                              </Col>
                              <Col lg="4">
                                  <div className="mb-3">
                                      <Label className="form-label" htmlFor="basicpill-address-input1">Description - Eng</Label>
                                      <textarea id="basicpill-address-input1" className="form-control" rows="5" onChange={(e) =>setDesc_Eng(e.target.value)} value={DesZone_Eng }></textarea>
                                  </div>
                              </Col>
                          </Row>
                        </Row>
                      </React.Fragment>
              </ModalBody>
                      {!isObjectEmpty(ZoneOpened) ? 
                      <div style={{display : 'flex', alignItems : 'center' , justifyContent : 'center',margin : 10}}>
                          <Button
                              type="button"
                              color="primary" className="waves-effect waves-light"
                              onClick={handleupdateZone}
                          >
                              Mise à jour
                          </Button>
                      </div>
                       :
                      <div style={{display : 'flex', alignItems : 'center' , justifyContent : 'center',margin : 10}}>
                          <Button
                              type="button"
                              color="primary" className="waves-effect waves-light"
                              onClick={AddAnim}
                          >
                              Enregistrer
                          </Button>
                      </div>
                  }

          </Modal>

        

          <Modal
               isOpen={ShowConfirmModal}
               toggle={() => setShowConfirmModal(false)}
               backdrop="static"
             >
               <ModalHeader toggle={() => setShowConfirmModal(false) }>
                Désactiver l'animal
               </ModalHeader>
               <ModalBody>
                 <p>
                 Voulez-vous désactiver cette Animal? 
               </p>
               <ModalFooter>
                 <Button type="button" color="light" onClick={() => setShowConfirmModal(false) }>Non</Button>
                 <Button type="button" color="primary" onClick={handleClickRemove} >Oui</Button>
               </ModalFooter>  
               </ModalBody>
          </Modal>

          <Modal
               isOpen={ShowConfirmModalII}
               toggle={() => setShowConfirmModalII(false)}
               backdrop="static"
             >
               <ModalHeader toggle={() => setShowConfirmModalII(false) }>
                Activer l'animal
               </ModalHeader>
               <ModalBody>
                 <p>
                 Voulez-vous activer cette Animal? 
               </p>
               <ModalFooter>
                 <Button type="button" color="light" onClick={() => setShowConfirmModalII(false) }>Non</Button>
                 <Button type="button" color="primary" onClick={handleClickEnable} >Oui</Button>
               </ModalFooter>  
               </ModalBody>
          </Modal>

          
        </Container>
        {/* <Modal
            isOpen={modalUpdateIsOpen}
            onRequestClose={closeModal} 
            style={customStyles}
          ></Modal> */}
      </div>
    </React.Fragment>
  );
};

export default Vivarum;
